import historyTable from '../api/historyTable';
import {
  GET_HISTORY_BEGIN,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE,
  SET_UPLOADS_HISTORY_DATA,
} from './types';

export default {
  namespaced: true,
  state: {
    uploadsHistoryTableData: [],
    gettingHistory: false,
    gettingHistoryCompleted: false,
    gettingHistoryError: false,
  },
  actions: {
    getHistory({ commit }) {
      commit(GET_HISTORY_BEGIN);
      return historyTable.getHistory()
        .then(({ data }) => {
          console.log('data', data)
          if (data['error'] === true) {
            commit(GET_HISTORY_FAILURE);
            return;
          }
          commit(SET_UPLOADS_HISTORY_DATA, data['data'])
        })
        .then(() => commit(GET_HISTORY_SUCCESS))
        .catch(() => commit(GET_HISTORY_FAILURE));
    },
  },
  mutations: {
    [GET_HISTORY_BEGIN](state) {
      state.gettingHistory = true;
      state.gettingHistoryError = false;
    },
    [GET_HISTORY_FAILURE](state) {
      state.gettingHistory = false;
      state.gettingHistoryCompleted = false;
      state.gettingHistoryError = true;
    },
    [GET_HISTORY_SUCCESS](state) {
      state.gettingHistory = false;
      state.gettingHistoryCompleted = true;
      state.gettingHistoryError = false;
    },
    [SET_UPLOADS_HISTORY_DATA](state, data) {
      state.uploadsHistoryTableData = data;
    },
  },
};
 



// WEBPACK FOOTER //
// ./src/store/historyTable.js